// --- Framework
import React from 'react';
import PropTypes from 'prop-types';

// --- External tools
import { makeStyles } from '@material-ui/core/styles';

// --- Style
import './ItemHeader.sass';

const useStyles = makeStyles(theme => ({
	price: {
		fontWeight: 600,
		padding: 0,
		margin: '0 8px',
		color: theme.palette.text.primary,

		// NOTE
		// Props can be accessed from here as they are passed to the useStyle method below:
		// color: (props) => props.myColorProp,
	},
}));


const ItemHeader = (props) => {
	const {
		icon,
		size,
		leftTitle,
		leftSubtitle,
		rightTitle,
	} = props;

	// NOTE
	// This is currently not used, so the makeStyles method above has no effect.
	const classes = useStyles(props);

	return (
		<div className="itemHeader">
{/*			<div className={`iconContainer${size}`}>
				{icon}
			</div>
*/}
			<div className="leftContainer">
				<h2 className={`title${size}`}>
					{leftTitle}
					{/*
					{' '}
					<span className="subtitle">
						{leftSubtitle}
					</span>
					*/}
				</h2>
				<h4 className={`subtitle${size}`}>
					{leftSubtitle}
				</h4>
			</div>
			<div className="rightContainer">
				<h3 className="title">
					{rightTitle}
				</h3>
			</div>
		</div>
	);
};

ItemHeader.propTypes = {
	icon: PropTypes.any,
	size: PropTypes.string,
	leftTitle: PropTypes.string,
	leftSubtitle: PropTypes.string,
	rightTitle: PropTypes.string,
};

ItemHeader.defaultProps = {
	size: ''
};

export default ItemHeader;
